import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Form, Button } from "reactstrap";
import TextField from "../../../common/TextField";
import { toast } from "react-toastify";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { createStageService } from "../../../../Services/CRMAdminServices/CRMStagesService";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";

export default function AddStages() {
    const queryClient = useQueryClient();
    const navigate = useSafeNavigate();
    const [formData, setFormData] = useState({ name: "", orderBy: "" });
    const [formErrors, setFormErrors] = useState<any>({});

    const handleValueChange = (name: string, value: string) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setFormErrors((prevErrors : any) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const { mutate: addStage, isPending: isAddingStage } = useMutationRequestQuery("addStage", createStageService, {
        onSuccess: () => {
            toast.success("Stage added successfully.");
            navigate("/CRMStages");
            queryClient.invalidateQueries({ queryKey: ["getAllStages"] });
        },
        onError: () => {
            toast.error("Failed to add stage.");
        },
    });

    const handleSubmit = (e: any) => {
        e.preventDefault();
        let errors: any = {};
        
        if (!formData.name) errors.name = "Stage Name is required!";
        if (!formData.orderBy) errors.orderBy = "Order By is required!";

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        
        addStage(formData);
    };

    return (
        <div className="px-4 py-4" style={{ minHeight: "300px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
            <Form style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "white", borderRadius: "8px", padding: "15px", paddingLeft: "30px" }}>
                <TextField
                    label="Stage Number:"
                    type="text"
                    name="orderBy"
                    value={formData.orderBy}
                    setValue={handleValueChange}
                    placeholder="Enter stage number"
                    passCol="col-4"
                    design="flex"
                    maxChars={10}
                    error={formErrors.orderBy}
                    errorMessage="Stage number is required!"
                />
                <TextField
                    label="Stage:"
                    type="text"
                    name="name"
                    value={formData.name}
                    setValue={handleValueChange}
                    placeholder="Enter stage name"
                    passCol="col-4"
                    design="flex"
                    maxChars={50}
                    error={formErrors.name}
                    errorMessage="Stage Name is required!"
                />
                <div className="d-flex gap-3 mt-3">
                    <Button onClick={() => navigate("/CRMStages")} color="secondary">Back to Stages</Button>
                    <Button onClick={handleSubmit} color="primary" disabled={isAddingStage} type="submit">
                        {isAddingStage ? "Saving..." : "Save Stage"}
                    </Button>
                </div>
            </Form>
        </div>
    );
}